var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[(_vm.visibility)?_c('div',[_c('v-row',{staticClass:"navbar",attrs:{"no-gutters":"","align":"center"}},[_c('span',{staticClass:"navbar-title"},[_vm._v("瑞達線上服務平台")]),_c('v-spacer'),(_vm.menu_btn_visibility)?_c('MenuButton'):_vm._e()],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }